module.exports = __webpack_public_path__ + "img/ha-default.2fd30b8e.png";